import Header from "@/shared/components/Header";
import Footer from "@/shared/components/Footer";
import Head from 'next/head';
import React, { useState, useEffect } from "react";
import styles from './styles.module.css';
import { PagegrowlerFunctions } from "@pagegrowler_nextjs";
import GenericSlider from "./components/Slider";
import SocialShare from "./components/SocialShare/social-share";
import BannerHorizontalChico from '@/widgets/Banner/Templates/BannerHorizontalChico';
import { ArrowsDouble } from '@/icons/index'
import PagegrowlerList from '@/widgets/Listado/Templates/PagegrowlerList'
import Templates from '@/widgets/index';
import LdJsonGallery from './components/Ldjson';

function Nota(props) {
	const CLIPPING_GALLERY = 'Galeria_XL_1565x0';
	const CLIPPING_THUMBNAIL = '3_2_230x153';

	const [isSliderActive, setIsSliderActive] = useState(false);
	const [startingIndex, setStartingIndex] = useState(0);

	//const [imgList, setImgList] = useState([]);
	const pagegrowlerFunctions = PagegrowlerFunctions();

	const {
		title,
		body,
		url,
		description,
		keywords,
		sections,
		tags,
		publishedDate,
		modificatedAt
	} = { ...props.content };

	let menues = props.menu ? props.menu : [];
	const [open, setOpen] = useState(false);

	const setImg = (element, clipping) => {
		let elementImg = {
			images: [
				element.value &&
				{
					clippings: element.value.clippings || [],
					title: element.value.title || ''
				}
			]
		};
		return pagegrowlerFunctions.getFullImageObject(elementImg, clipping, process.env.NEXT_PUBLIC_IMAGE_DOMAIN);
	}
	let imgList = [];
	let images = body.map((el) => {
		let bigImgObj = setImg(el, CLIPPING_GALLERY);
		let smallImgObj = setImg(el, CLIPPING_THUMBNAIL);
		let imgObj = {
			bigImgUrl: bigImgObj.url,
			smallImgUrl: smallImgObj.url,
			author: el.author,
			epigraphe: el.epigraphe
		}
		return imgObj;
	});

	imgList = images;

	let sectionUrl = url.split('/');
	sectionUrl.pop();
	sectionUrl = "/seccion" + sectionUrl.join('/');

	const galleryDescription = description || title;
	const keywordsContent = keywords || (tags && tags.length > 0 ? tags.map(t => t.name).join(', ') : '');
	const metaImageUrl = imgList && imgList.length > 0
		? imgList[0].bigImgUrl
		: `${process.env.NEXT_PUBLIC_DOMAIN_URL || 'https://www.ellitoral.com'}/img/img-default-share.jpeg`;

	function openSlider(openIndex, e) {
		setStartingIndex(openIndex);
		setIsSliderActive(true);
	}

	function closeSlider() {
		setIsSliderActive(false);
	}

	function backToFn() {
		window.location.href = `/fotos-hd`;
	}
	return (
		<>
			<Head>
				<title>[Galería] {title}</title>
				<meta name="title" content={`[Galería] ${title}`} />
				<meta name="description" content={galleryDescription} />
				<meta name="author" content="Ellitoral.com" />
				<meta name="distribution" content="global" />
				<meta name="robots" content="max-image-preview:large" />
				{keywordsContent && <meta name="keywords" content={keywordsContent} />}
				{keywordsContent && <meta name="news_keywords" content={keywordsContent} />}

				{/* Open Graph */}
				<meta property="og:type" content="article" />
				<meta property="og:site_name" content="El Litoral" />
				<meta property="og:locale" content="es_AR" />
				<meta property="og:url" content={process.env.NEXT_PUBLIC_DOMAIN_URL + url} />
				<meta property="og:title" content={`[Galería] ${title}`} />
				<meta property="og:description" content={galleryDescription} />
				<meta property="og:image" content={metaImageUrl} />
				<meta property="og:image:width" content="1565" />

				{/* Fechas */}
				{publishedDate && <meta property="article:published_time" content={publishedDate} />}
				{modificatedAt && <meta property="article:modified_time" content={modificatedAt} />}
				{sections && sections[0] && <meta property="article:section" content={sections[0].name} />}

				{/* Twitter Card */}
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@ellitoral" />
				<meta name="twitter:creator" content="@ellitoral" />
				<meta name="twitter:title" content={`[Galería] ${title}`} />
				<meta name="twitter:description" content={galleryDescription} />
				<meta name="twitter:image" content={metaImageUrl} />

				<link rel="canonical" href={process.env.NEXT_PUBLIC_DOMAIN_URL + url} />
				<link rel="image_src" href={metaImageUrl} />
				{imgList.length > 0 && <link rel="preload" href={imgList[0].bigImgUrl} as="image" fetchpriority="high" />}
			</Head>
			<LdJsonGallery
				content={props.content}
				url={process.env.NEXT_PUBLIC_DOMAIN_URL + url}
				imgList={imgList}
				sections={sections}
				sectionUrl={sectionUrl}
			/>
			<Header menues={menues} isOpenSidePanel={(open) => setOpen(open)} />
			
			<div className={`${styles["parent"]}`}>
				<div className={`${styles['container']}`}>
					<GenericSlider
						imgList={imgList}
						quantity={imgList.length}
						isSliderActive={isSliderActive}
						startingIndex={startingIndex}
						closeSlider={closeSlider}
						backToFn={backToFn}
						shareUrl={url}
					/>
					{!props.preview &&
						<div className={styles['banner-container']}>
							<BannerHorizontalChico bannerId={'top'} />
						</div>
					}

					<h1 className={`${styles['main-title']}`}>{title}</h1>
					<hr />
					
					<div className={`${styles['social-top']}`}>
						<SocialShare galleryUrl={url} align={"center"} bgColor={'216497'} />
					</div>


					<div className={styles['grid-container']}>
						<div className={styles['container-parent']}>
							{imgList.map((el, index) => {
								return (
									<div key={el + index}>
										<div className={`${styles['image-container']}`}>
											<img className={`${styles['image']}`} {...(index === 0 ? { fetchpriority: 'high' } : { loading: 'lazy' })} alt={el.epigraphe} style={{ width: '600px', height: '600px' }} src={el.bigImgUrl} onClick={(e) => openSlider(index, e)} />
											<a className={`${styles['expand-container']}`} onClick={(e) => openSlider(index, e)}>
												<ArrowsDouble className={`${styles['rotate--45-dg']}`}/>
												<span>AMPLIAR</span>
											</a>
											<div className={`${styles['share-container']}`}>
												<SocialShare galleryUrl={url} />
											</div>
										</div>
										<p><strong>{index + 1} / {imgList.length}</strong> {el.epigraphe} {el.author && <strong>Foto: {el.author}</strong>}</p>
										<hr className={`${styles['marginBottom-L']}`} />
									</div>

								)
							})}
							

							{/* carrousel galerias */}
                                    <div className={`${styles['cont-carru']}`}>
                                        <PagegrowlerList widget='CarouselDeGalerias' url='top-gallery' fallbackUrl='top-lilanews' isMobile={false}/>
										<PagegrowlerList widget='CarouselDeGalerias' url='top-gallery' fallbackUrl='top-lilanews' isMobile={true}/>

                                    </div>


						</div>
						<div className={styles['container-list']}>
							<PagegrowlerList url='column-gallery' fallbackUrl="column-lilanews"/>
						</div>
					</div>
					<div className={styles['container-interesar']}>
						{!props.preview && <BannerHorizontalChico bannerId={'horizontal1'} />}
						<PagegrowlerList  widget='TePuedeInteresar' url='bottom-gallery' fallbackUrl='bottom-lilanews' />
					</div>
					<div className={styles['container-interesar']}>
						<PagegrowlerList
							widget="SeccionVideos"
							url="top-video"
							fallbackUrl="top-lilanews"
							overrideProps={{ title: "Videos", link: "/videos" }}
						/>
					</div>
					<div className={styles['container-interesar']}>
						<PagegrowlerList
							widget="SeccionGalerias"
							url="top-gallery"
							fallbackUrl="top-lilanews"
							overrideProps={{ title: "Otras Galerías", link: "/fotos-hd" }}
						/>
					</div>
				</div>

			</div>
			<div style={{ clear: 'both' }}>
				<Footer />
			</div>
		</>
	);
}

export default Nota;
